"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("../component.js"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*---------------------------------------------*/
// TODO: better handle controlled components.
// if the component is controlled - no reason to manage value in state.
// currently, the value is being modified even if externally it's fixed.

/*---------------------------------------------*/
var NumberInput = /*#__PURE__*/function (_Component) {
  _inherits(NumberInput, _Component);

  var _super = _createSuper(NumberInput);

  function NumberInput() {
    var _this;

    _classCallCheck(this, NumberInput);

    _this = _super.call(this, {
      keyboardFocusOnly: true
    });
    _this.state = {
      value: ""
    };
    /*--*/

    _this.increment = _this.increment.bind(_assertThisInitialized(_this));
    _this.decrement = _this.decrement.bind(_assertThisInitialized(_this));
    /*--*/

    _this.onCaretMouseDown = _this.onCaretMouseDown.bind(_assertThisInitialized(_this));
    _this.onCaretUpMouseUp = _this.onCaretUpMouseUp.bind(_assertThisInitialized(_this));
    _this.onCaretDownMouseUp = _this.onCaretDownMouseUp.bind(_assertThisInitialized(_this));
    /*--*/

    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(NumberInput, [{
    key: "increment",
    value: function increment() {
      this.onChange((1 * this.state.value || 0) + 1);
    }
  }, {
    key: "decrement",
    value: function decrement() {
      this.onChange((1 * this.state.value || 0) - 1);
    }
  }, {
    key: "onChange",
    value: function onChange(value) {
      var pattern = /^-?\d*\.?\d*$/;
      if (!pattern.test(value)) return;
      value = Number(value);
      this.setState({
        value: value
      });
      this.props.onChange && this.props.onChange(value, this.props.name);
    }
  }, {
    key: "onCaretMouseDown",
    value: function onCaretMouseDown(e) {
      // prevent carets (arrows) clicks from affecting the input focus
      e.preventDefault();
    }
  }, {
    key: "onCaretUpMouseUp",
    value: function onCaretUpMouseUp() {
      this.increment();
    }
  }, {
    key: "onCaretDownMouseUp",
    value: function onCaretDownMouseUp() {
      this.decrement();
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      switch (event.key) {
        case "ArrowUp":
          {
            event.preventDefault();
            this.increment();
            break;
          }

        case "ArrowDown":
          {
            event.preventDefault();
            this.decrement();
            break;
          }

        default:
          break;
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      this.setState({
        keyboardFocus: this.focusedViaKeyboard
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.setState({
        hoverIndex: 0,
        keyboardFocus: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);
      this.state.keyboardFocus && this.addClass("lth-has-keyboardfocus");
      var value = this.props.value || this.state.value;

      var carets = /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__carets"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__caret",
        onMouseDown: this.onCaretMouseDown,
        onMouseUp: this.onCaretUpMouseUp
      }, /*#__PURE__*/_react.default.createElement(_.Icon, {
        className: "icon",
        color: "inherit",
        icon: "caretUp",
        size: 20
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__caret",
        onMouseDown: this.onCaretMouseDown,
        onMouseUp: this.onCaretDownMouseUp
      }, /*#__PURE__*/_react.default.createElement(_.Icon, {
        className: "icon",
        color: "inherit",
        icon: "caretDown",
        size: 20
      })));

      var inputProps = _objectSpread(_objectSpread({}, this.props), {}, {
        type: "text",
        value: value,
        iconRight: carets,
        inputWidth: this.props.digits && "".concat(this.props.digits * DIGIT_WIDTH_EM, "em"),
        inputMode: "numeric",
        pattern: "[0-9]*",
        onKeyDown: this.onKeyDown,
        onChange: this.onChange
      });

      return /*#__PURE__*/_react.default.createElement("div", {
        style: this.getStyle(),
        className: this.getClassNames(),
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }, /*#__PURE__*/_react.default.createElement(_.Input, inputProps));
    }
  }]);

  return NumberInput;
}(_component.default);
/*---------------------------------------------*/


exports.default = NumberInput;

_defineProperty(NumberInput, "BASE_CLASS", "lth-c-numberinput");

var DIGIT_WIDTH_EM = 0.56163;
/*---------------------------------------------*/

NumberInput.METADATA = {
  name: "Numberinput",
  props: [{
    name: "label",
    type: "string",
    default: "Enter your input"
  }, {
    name: "value",
    type: "string",
    default: undefined
  }, {
    name: "size",
    type: "string",
    default: "normal",
    description: "Choose the size",
    options: [{
      value: "slim"
    }, {
      value: "normal"
    }]
  }, {
    name: "placeholder",
    type: "string"
  }, {
    name: "units",
    type: "string"
  }, {
    name: "digits",
    type: "number",
    category: "view"
  }, {
    name: "tooltip",
    type: "string"
  }, {
    name: "disabled",
    type: "boolean",
    default: false
  }, {
    name: "error",
    type: "boolean",
    default: false
  }, {
    name: "forcehover",
    type: "boolean",
    default: false
  }, {
    name: "forcefocus",
    type: "boolean",
    default: false
  }, {
    name: "message",
    type: "string"
  }, {
    name: "onChange",
    type: "function"
  }]
};